// A small "Night mode" chip for the Baby Button area (e.g. <BabyButton><NightModeLink /></BabyButton> on the Plan tab).
// Opens /sounds/night; kept tiny so the Plan tab does not pull in the night mode code.
import { Link } from 'react-router';
import { useTranslation } from 'react-i18next';

export function EarIcon() {
  return (
    <svg viewBox="0 0 24 24" aria-hidden="true" className="ear-icon">
      <path d="M6 8.5a6.5 6.5 0 1 1 13 0c0 6-6 6-6 10a3.5 3.5 0 1 1-7 0" />
      <path d="M15 8.5a2.5 2.5 0 0 0-5 0v1a2 2 0 1 1 0 4" />
    </svg>
  );
}

export function NightModeLink() {
  const { t } = useTranslation('sounds');
  return (
    <Link className="chip" to="/sounds/night" state={{ from: 'baby_button' }}>
      <EarIcon />
      <span>{t('entry.link')}</span>
    </Link>
  );
}
